@if (isVisible()) {
  <rt-impact-tracker-banner
    [subheading]="'tlc.impact_tracker.metrics_banner.subheading' | translate"
    [headingHTML]="
      'tlc.impact_tracker.metrics_banner.heading_html'
        | translate
          : { companyName: impactTrackerService.orgName(), total: impactTrackerService.total() }
    "
    [lsKey]="'impact-tracker-insights-banner-dismissed'"
    [lsExpirationInterval]="expirationInMs"
    (dismissed)="impactTrackerAnalytics.trackBannerDisplayed()"
  >
    <ng-container icon>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.9785 25.6464C23.9785 26.7227 23.812 27.498 23.4773 27.9724C23.1424 28.4467 22.6252 28.6839 21.9255 28.6839C21.2258 28.6839 20.7567 28.4547 20.4218 27.9962C20.0871 27.5378 19.9206 26.8642 19.9206 25.9773V16.6715H29.0827L30.1393 10.7361H19.9187V5L12.4687 8.04146V10.7381H8.57129C8.57129 13.2913 10.1952 15.4617 12.4687 16.2989V26.1208C12.4687 28.0202 12.8276 29.6346 13.5433 30.964C14.259 32.2934 15.3015 33.2979 16.6708 33.9795C18.0401 34.6592 19.7423 35 21.7812 35C23.82 35 25.418 34.6193 26.8675 33.86C28.3149 33.1006 29.4376 32.0323 30.2335 30.6551C31.0295 29.2778 31.4284 27.6734 31.4284 25.8358V20H23.9785V25.6464Z"
          fill="var(--color-icon-impact-default)"
        />
      </svg>
    </ng-container>

    @if (impactTrackerService.canShowDialogTrigger()) {
      <ng-container cta>
        <rt-button (click)="openDialog()" variant="tertiary">
          <span>{{ 'tlc.impact_tracker.metrics_banner.cta' | translate }}</span>
          <rt-icon name="arrow-forward" />
        </rt-button>
      </ng-container>
    }
  </rt-impact-tracker-banner>
}
